const CLIPPING_OVERFLOW_VALUES = new Set(["auto", "scroll", "hidden", "clip"]);

function isClippingContainer(element) {
  const styles = window.getComputedStyle(element);

  return [styles.overflow, styles.overflowX, styles.overflowY].some((value) =>
    CLIPPING_OVERFLOW_VALUES.has(value),
  );
}

function getDropdownBoundary(triggerElement) {
  let current = triggerElement.parentElement;

  while (current && current !== document.body) {
    if (current.classList.contains("roles-table")) {
      return current;
    }

    if (isClippingContainer(current)) {
      return current;
    }

    current = current.parentElement;
  }

  return null;
}

export function getActionDropdownDirection(
  triggerElement,
  { menuHeight = 104, margin = 12 } = {},
) {
  if (!triggerElement || typeof window === "undefined") {
    return "down";
  }

  const triggerRect = triggerElement.getBoundingClientRect();
  let spaceBelow = window.innerHeight - triggerRect.bottom - margin;
  let spaceAbove = triggerRect.top - margin;

  const boundary = getDropdownBoundary(triggerElement);

  if (boundary) {
    const boundaryRect = boundary.getBoundingClientRect();

    spaceBelow = Math.min(
      spaceBelow,
      boundaryRect.bottom - triggerRect.bottom - margin,
    );
    spaceAbove = Math.min(
      spaceAbove,
      triggerRect.top - boundaryRect.top - margin,
    );
  }

  if (spaceBelow >= menuHeight) {
    return "down";
  }

  if (spaceAbove >= menuHeight) {
    return "up";
  }

  return "down";
}
